var __TEMP__ = require('./_getMapData.js');var getMapData = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = mapCacheHas;
